import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBag2"><Path d="M2.50391 20.5H21.5017V7.5H2.50391V20.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M16 20.25V3.5H8V20.25" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBag2;
